import { render, staticRenderFns } from "./EditorVentas.vue?vue&type=template&id=5ed6fc11&scoped=true"
import script from "./EditorVentas.vue?vue&type=script&lang=js"
export * from "./EditorVentas.vue?vue&type=script&lang=js"
import style0 from "./EditorVentas.vue?vue&type=style&index=0&id=5ed6fc11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6fc11",
  null
  
)

export default component.exports